import { ChangeDetectionStrategy, Component, computed, input, InputSignal, Signal } from '@angular/core';
import { IGoalResponse } from 'app/features/goal/models/goal.models';
import { GoalProgressBarComponent } from '../goal-progress-bar/goal-progress-bar.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [GoalProgressBarComponent],
  selector: 'app-goal-header',
  templateUrl: './goal-header.component.html',
  styleUrl: './goal-header.component.scss',
})
export class GoalHeaderComponent {
  readonly goalData: InputSignal<IGoalResponse> = input.required<IGoalResponse>();
  isAstraZeneca: Signal<boolean> = computed(() => this.goalData().user.username.toLowerCase().includes('astrazeneca'));
}
